module.exports = __webpack_public_path__ + "static/media/this-really-sends-me.c2de1e4e.txt";